import { OKCancelButtonsProps } from "types/modals";
import { Button, ButtonType } from "components/common/Button.component";

export const OKCancelButtons = ({
    tabIndex,
    okEnabled,
    cancelEnabled,
    okCallback,
    okText,
    cancelText,
    cancelCallback,
    loopFocus,
    okRef,
}: OKCancelButtonsProps) => (
    <div className="ga-modal__actions">
        <Button
            ref={okRef}
            type={ButtonType.PRIMARY}
            text={okText}
            onClick={okCallback}
            disabled={!okEnabled}
            tabIndex={tabIndex}
            extraClassName="btn-margin-right ast_ok_btn"
        />
        <Button
            type={ButtonType.SECONDARY}
            text={cancelText}
            onClick={cancelCallback}
            disabled={!cancelEnabled}
            onBlur={loopFocus}
            tabIndex={tabIndex + 1}
            extraClassName="ast_cancel_btn"
        />
    </div>
);

export default OKCancelButtons;